import * as types from '../types';

const initialState = {
    privacyPolicy: {
        title: '',
        text: ''
    }
};

const reducer = (state = initialState, action) => {
    const { payload } = action;

    switch (action.type) {

        case types.GET_PRIVACY_POLICY:
            const privacyPolicy = payload.docs.length ? payload.docs[0] : state.privacyPolicy;
            return { ...state, privacyPolicy }

        default:
            return { ...state };
    }
}


export default reducer;
